import { render } from "./CrearUbicacion.vue?vue&type=template&id=aa5f78ae&scoped=true"
import script from "./CrearUbicacion.vue?vue&type=script&lang=js"
export * from "./CrearUbicacion.vue?vue&type=script&lang=js"

import "./CrearUbicacion.vue?vue&type=style&index=0&id=aa5f78ae&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5f78ae"]])

export default __exports__